export default __webpack_public_path__ + "static/media/rideco.fa699a6e.jpg";